<template>
  <div ref="echart01" style="width:100%; height:200px;"></div>
</template>

<script>
export default {
  props:{
    data05:{type: Object}
  },
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    // let xdata = ['2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022']
    let xdata = this.data05.years
    // let ydata = [13, 1, 4, 44, 45, 322, 76, 44, 45, 76]
    let ydata = this.data05.fwdwbh
    let option = {
      backgroundColor: '#fff',
      title: {
        text: '单位数',
        left: '18px',
        top: '0',
        textStyle: {
          color: '#999',
          fontSize: 12,
          fontWeight: '400'
        }
      },
      color: ['#73A0FA'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          },
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      grid: {
        left: '2%',
        right: '2',
        bottom: '24',
        top: '25',
        containLabel: true
      },
      legend: {
        data: ['单位数'],
        orient: 'horizontal',
        icon: 'rect',
        show: true,
        left: '50%',
        top: 0
      },
      xAxis: {
        type: 'category',
        data: xdata,
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        // max: max_value>=100? max_value + 100: max_value+10,
        // max: max_value > 100 ? max_value * 2 : max_value + 10,
        // interval: 10,
        // nameLocation: "center",
        axisLabel: {
          color: '#999',
          textStyle: {
            fontSize: 12
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#F3F4F4'
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      series: [
        {
          name: '单位数',
          type: 'line',
          itemStyle:{
            normal:{
              label : {
                show: true // 在折线拐点上显示数据
              }
            }
          },
          smooth: true,
          data: ydata
        }
      ]
    }

    chart01.setOption(option, true)
  }
}
</script>

<style></style>
